/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface NoteControllerFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 노트 내용 */
    content: string;
    /** 업데이트 날짜 */
    updatedAt: string | null;
    /** 수정자 이름 */
    modifierName: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface NoteControllerUpdateBodyRequest {
  /** 병원서비스 ID */
  hserviceID: string;
  /** 환자 ID */
  userID: string;
  /** 치료 내역 내용 */
  content?: string;
}

export interface NoteControllerUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 노트 내용 */
    content?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ColumnControllerFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 컬럼 ID */
    _id: string;
    /** 컬럼 제목 */
    title: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 예약 그룹 ID (populate된 경우 객체, 아닌 경우 문자열) */
    groupID?:
      | string
      | {
          _id: string;
        };
    /** 담당자 ID */
    employeeID?: string;
    /** 알림 대상 사용자 ID 배열 */
    notificationUsers?: string[];
    /** 앱 프로그램 ID 배열 */
    appPrograms?: string[];
    /** 수정자 ID */
    modifierID?: string;
    /** 프로그램 목록 */
    programs: {
      /** 프로그램 ID */
      _id: string;
      /** 프로그램 제목 */
      title: string;
      /** 프로그램 소요 시간(분) */
      duration?: number;
      /** 프로그램 설명 */
      description?: string;
      /** 병원 ID */
      hospitalID?: string;
      /** 삭제 여부 */
      isRemoved?: boolean;
      /** 정렬 번호 */
      sortNum?: number;
      /** 기본 프로그램 여부 */
      isDefault?: boolean;
    }[];
    /** 기본 굵은 간격 사용 여부 */
    usingDefaultBoldInterval?: boolean;
    /** 굵은 간격 */
    boldInterval?: number;
    /** 굵은 시간 간격 배열 */
    boldTimeIntervals?: string[];
    /** 활성화 여부 */
    isActive?: boolean;
    /** 생성 가능 타입 */
    canCreateType?: string;
    /** 생성 가능 범위 */
    possibleCreateRange?: number;
    /** 당일 차단 사용 여부 */
    usingSameDayBlock?: boolean;
    /** 당일 차단 타입 */
    sameDayBlockType?: string;
    /** 당일 차단 지속 시간 */
    sameDayBlockDuration?: number;
    /** 수정 가능 여부 */
    canModify?: boolean;
    /** 수정 가능 타입 */
    canModifyType?: string;
    /** 수정 가능 범위 */
    possibleModifyRange?: number;
    /** 기본 앱 간격 사용 여부 */
    usingDefaultAppInterval?: boolean;
    /** 앱 간격 */
    appInterval?: number;
    /** 앱 시간 간격 배열 */
    appTimeIntervals?: string[];
    /** 앱 최대 수용 인원 */
    appMaxCapacity?: number;
    /** 정렬 번호 */
    sortNum?: number;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** AI 사용 여부 */
    isAi?: boolean;
    /** AI 생성 시작 단위 - hour/day */
    aiSameDayBlockType?: string;
    /** AI 생성 가능 범위 시작 */
    aiSameDayBlockDuration?: number;
    /** AI 생성 가능 범위 종료 */
    aiPossibleCreateRange?: number;
    /** AI 기본 앱 간격 사용 여부 */
    aiUsingDefaultAppInterval?: boolean;
    /** AI 앱 간격 */
    aiAppInterval?: number;
    /** AI 앱 시간 간격 배열 */
    aiAppTimeIntervals?: string[];
    /** AI 앱 최대 수용 인원 */
    aiAppMaxCapacity?: number;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
    /**
     * 삭제된 일시
     * @format date
     */
    removedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ColumnControllerCreateBodyRequest {
  /** (required) 병원 ID */
  hospitalID: string;
  /** (required) 예약 그룹 ID */
  groupID: string;
  /** (required) 컬럼(담당자) 이름 */
  title: string;
  /** 담당자 ID */
  employeeID?: string;
  /** 알림 대상 사용자 ID 배열 */
  notificationUsers?: string[];
  /** 프로그램 ID 배열 */
  programs?: string[];
  /** 앱 프로그램 ID 배열 */
  appPrograms?: string[];
  /** 굵은 간격 */
  boldInterval?: number;
  /** 굵은 시간 간격 배열 */
  boldTimeIntervals?: string[];
  /** 활성화 여부 */
  isActive?: boolean;
  /** 기본 굵은 간격 사용 여부 */
  usingDefaultBoldInterval?: boolean;
  /** 생성 가능 타입 */
  canCreateType?: string;
  /** 생성 가능 범위 */
  possibleCreateRange?: number;
  /** 당일 차단 사용 여부 */
  usingSameDayBlock?: boolean;
  /** 당일 차단 타입 */
  sameDayBlockType?: string;
  /** 당일 차단 지속 시간 */
  sameDayBlockDuration?: number;
  /** 수정 가능 여부 */
  canModify?: boolean;
  /** 수정 가능 타입 */
  canModifyType?: string;
  /** 수정 가능 범위 */
  possibleModifyRange?: number;
  /** 취소 가능 여부 */
  canCancel?: boolean;
  /** 취소 가능 타입 */
  canCancelType?: string;
  /** 취소 가능 범위 */
  possibleCancelRange?: number;
  /** 기본 앱 간격 사용 여부 */
  usingDefaultAppInterval?: boolean;
  /** 앱 간격 */
  appInterval?: number;
  /** 앱 시간 간격 배열 */
  appTimeIntervals?: string[];
  /** 앱 최대 수용 인원 */
  appMaxCapacity?: number;
}

export interface ColumnControllerCreateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 컬럼 ID */
    _id: string;
    /** 컬럼 제목 */
    title: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 예약 그룹 ID */
    groupID?: string;
    /** 담당자 ID */
    employeeID?: string;
    /** 알림 대상 사용자 ID 배열 */
    notificationUsers?: string[];
    /** 프로그램 ID 배열 */
    programs?: string[];
    /** 앱 프로그램 ID 배열 */
    appPrograms?: string[];
    /** 수정자 ID */
    modifierID?: string;
    /** 활성화 여부 */
    isActive?: boolean;
    /** 정렬 번호 */
    sortNum?: number;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ColumnControllerAiColumnGetResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 컬럼 ID */
    _id: string;
    /** 컬럼 제목 */
    title: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 예약 그룹 ID (populate된 경우 객체, 아닌 경우 문자열) */
    groupID?:
      | string
      | {
          _id: string;
        };
    /** 담당자 ID */
    employeeID?: string;
    /** 알림 대상 사용자 ID 배열 */
    notificationUsers?: string[];
    /** 앱 프로그램 ID 배열 */
    appPrograms?: string[];
    /** 수정자 ID */
    modifierID?: string;
    /** 프로그램 목록 */
    programs: {
      /** 프로그램 ID */
      _id: string;
      /** 프로그램 제목 */
      title: string;
      /** 프로그램 소요 시간(분) */
      duration?: number;
      /** 프로그램 설명 */
      description?: string;
      /** 병원 ID */
      hospitalID?: string;
      /** 삭제 여부 */
      isRemoved?: boolean;
      /** 정렬 번호 */
      sortNum?: number;
      /** 기본 프로그램 여부 */
      isDefault?: boolean;
    }[];
    /** 기본 굵은 간격 사용 여부 */
    usingDefaultBoldInterval?: boolean;
    /** 굵은 간격 */
    boldInterval?: number;
    /** 굵은 시간 간격 배열 */
    boldTimeIntervals?: string[];
    /** 활성화 여부 */
    isActive?: boolean;
    /** 생성 가능 타입 */
    canCreateType?: string;
    /** 생성 가능 범위 */
    possibleCreateRange?: number;
    /** 당일 차단 사용 여부 */
    usingSameDayBlock?: boolean;
    /** 당일 차단 타입 */
    sameDayBlockType?: string;
    /** 당일 차단 지속 시간 */
    sameDayBlockDuration?: number;
    /** 수정 가능 여부 */
    canModify?: boolean;
    /** 수정 가능 타입 */
    canModifyType?: string;
    /** 수정 가능 범위 */
    possibleModifyRange?: number;
    /** 기본 앱 간격 사용 여부 */
    usingDefaultAppInterval?: boolean;
    /** 앱 간격 */
    appInterval?: number;
    /** 앱 시간 간격 배열 */
    appTimeIntervals?: string[];
    /** 앱 최대 수용 인원 */
    appMaxCapacity?: number;
    /** 정렬 번호 */
    sortNum?: number;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** AI 사용 여부 */
    isAi?: boolean;
    /** AI 생성 시작 단위 - hour/day */
    aiSameDayBlockType?: string;
    /** AI 생성 가능 범위 시작 */
    aiSameDayBlockDuration?: number;
    /** AI 생성 가능 범위 종료 */
    aiPossibleCreateRange?: number;
    /** AI 기본 앱 간격 사용 여부 */
    aiUsingDefaultAppInterval?: boolean;
    /** AI 앱 간격 */
    aiAppInterval?: number;
    /** AI 앱 시간 간격 배열 */
    aiAppTimeIntervals?: string[];
    /** AI 앱 최대 수용 인원 */
    aiAppMaxCapacity?: number;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
    /**
     * 삭제된 일시
     * @format date
     */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ColumnControllerAiColumnUpdateBodyRequest {
  /** (required) 컬럼 ID */
  _id: string;
  /** (required) 병원 ID */
  hospitalID: string;
  /** AI 생성 시작 단위 - hour/day */
  aiSameDayBlockType?: string;
  /** AI 예약생성 가능 범위 : 시작 */
  aiSameDayBlockDuration?: number;
  /** AI 예약생성 가능 범위 : 종료 */
  aiPossibleCreateRange?: number;
  /** AI 기본 앱 간격 사용 여부 */
  aiUsingDefaultAppInterval?: boolean;
  /** AI 앱 간격 */
  aiAppInterval?: number;
  /** AI 앱 시간 간격 배열 */
  aiAppTimeIntervals?: string[];
  /** AI 앱 최대 수용 인원 */
  aiAppMaxCapacity?: number;
}

export interface ColumnControllerAiColumnUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 컬럼 ID */
    _id: string;
    /** 컬럼 제목 */
    title: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 예약 그룹 ID (populate된 경우 객체, 아닌 경우 문자열) */
    groupID?:
      | string
      | {
          _id: string;
        };
    /** 담당자 ID */
    employeeID?: string;
    /** 알림 대상 사용자 ID 배열 */
    notificationUsers?: string[];
    /** 앱 프로그램 ID 배열 */
    appPrograms?: string[];
    /** 수정자 ID */
    modifierID?: string;
    /** 프로그램 목록 */
    programs: {
      /** 프로그램 ID */
      _id: string;
      /** 프로그램 제목 */
      title: string;
      /** 프로그램 소요 시간(분) */
      duration?: number;
      /** 프로그램 설명 */
      description?: string;
      /** 병원 ID */
      hospitalID?: string;
      /** 삭제 여부 */
      isRemoved?: boolean;
      /** 정렬 번호 */
      sortNum?: number;
      /** 기본 프로그램 여부 */
      isDefault?: boolean;
    }[];
    /** 기본 굵은 간격 사용 여부 */
    usingDefaultBoldInterval?: boolean;
    /** 굵은 간격 */
    boldInterval?: number;
    /** 굵은 시간 간격 배열 */
    boldTimeIntervals?: string[];
    /** 활성화 여부 */
    isActive?: boolean;
    /** 생성 가능 타입 */
    canCreateType?: string;
    /** 생성 가능 범위 */
    possibleCreateRange?: number;
    /** 당일 차단 사용 여부 */
    usingSameDayBlock?: boolean;
    /** 당일 차단 타입 */
    sameDayBlockType?: string;
    /** 당일 차단 지속 시간 */
    sameDayBlockDuration?: number;
    /** 수정 가능 여부 */
    canModify?: boolean;
    /** 수정 가능 타입 */
    canModifyType?: string;
    /** 수정 가능 범위 */
    possibleModifyRange?: number;
    /** 기본 앱 간격 사용 여부 */
    usingDefaultAppInterval?: boolean;
    /** 앱 간격 */
    appInterval?: number;
    /** 앱 시간 간격 배열 */
    appTimeIntervals?: string[];
    /** 앱 최대 수용 인원 */
    appMaxCapacity?: number;
    /** 정렬 번호 */
    sortNum?: number;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** AI 사용 여부 */
    isAi?: boolean;
    /** AI 생성 시작 단위 - hour/day */
    aiSameDayBlockType?: string;
    /** AI 생성 가능 범위 시작 */
    aiSameDayBlockDuration?: number;
    /** AI 생성 가능 범위 종료 */
    aiPossibleCreateRange?: number;
    /** AI 기본 앱 간격 사용 여부 */
    aiUsingDefaultAppInterval?: boolean;
    /** AI 앱 간격 */
    aiAppInterval?: number;
    /** AI 앱 시간 간격 배열 */
    aiAppTimeIntervals?: string[];
    /** AI 앱 최대 수용 인원 */
    aiAppMaxCapacity?: number;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
    /**
     * 삭제된 일시
     * @format date
     */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationSettingControllerFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 예약 설정 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 가능 시간대 배열 */
    possibleTimes?: {
      /** 요일 인덱스 (0: 일요일, 1: 월요일, ...) */
      index: number;
      /** 시작 시간 */
      startedAt: string;
      /** 종료 시간 */
      endedAt: string;
      /** 선택 여부 */
      isSelected?: boolean;
    }[];
    /**
     * 가능 시간대 수정 일시
     * @format date
     */
    possibleTimesModifiedAt?: string;
    /** 가능 시간대 수정자 정보 */
    possibleTimesModifierID?: {
      /** MongoDB Identifier */
      _id: string;
      /** 실 이름 */
      realName: string;
      /** 유저가 보는 이름 */
      name: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 병원내 계정의 직/직책 */
      jobType: string;
    };
    /** 셀 정보 타입 배열 (예: chartNumber, birth, note, programID) */
    cellInfo?: string[];
    /**
     * 셀 정보 수정 일시
     * @format date
     */
    cellInfoModifiedAt?: string;
    /** 셀 정보 수정자 정보 */
    cellInfoModifierID?: {
      /** MongoDB Identifier */
      _id: string;
      /** 실 이름 */
      realName: string;
      /** 유저가 보는 이름 */
      name: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 병원내 계정의 직/직책 */
      jobType: string;
    };
    /** 상태 색상 팔레트 객체 */
    statusColorPaletteID?: {
      /** 색상 팔레트 ID */
      _id: string;
      /** 병원 ID */
      hospitalID?: string;
      /** 기본 색상 팔레트 */
      basicPalette?: string[];
      /** 커스텀 색상 팔레트 */
      customPalette?: string[];
      /**
       * 생성 일시
       * @format date
       */
      createdAt?: string;
      /**
       * 수정 일시
       * @format date
       */
      updatedAt?: string;
    };
    /** 워크코드 색상 팔레트 객체 */
    workCodeColorPaletteID?: {
      /** 색상 팔레트 ID */
      _id: string;
      /** 병원 ID */
      hospitalID?: string;
      /** 기본 색상 팔레트 */
      basicPalette?: string[];
      /** 커스텀 색상 팔레트 */
      customPalette?: string[];
      /**
       * 생성 일시
       * @format date
       */
      createdAt?: string;
      /**
       * 수정 일시
       * @format date
       */
      updatedAt?: string;
    };
    /** 셀 색상 팔레트 객체 */
    cellColorPaletteID?: {
      /** 색상 팔레트 ID */
      _id: string;
      /** 병원 ID */
      hospitalID?: string;
      /** 기본 색상 팔레트 */
      basicPalette?: string[];
      /** 커스텀 색상 팔레트 */
      customPalette?: string[];
      /**
       * 생성 일시
       * @format date
       */
      createdAt?: string;
      /**
       * 수정 일시
       * @format date
       */
      updatedAt?: string;
    };
    /**
     * 프로그램 수정 일시
     * @format date
     */
    programModifiedAt?: string;
    /** 프로그램 수정자 정보 */
    programModifierID?: {
      /** MongoDB Identifier */
      _id: string;
      /** 실 이름 */
      realName: string;
      /** 유저가 보는 이름 */
      name: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 병원내 계정의 직/직책 */
      jobType: string;
    };
    /**
     * 상태 수정 일시
     * @format date
     */
    statusModifiedAt?: string;
    /** 상태 수정자 정보 */
    statusModifierID?: {
      /** MongoDB Identifier */
      _id: string;
      /** 실 이름 */
      realName: string;
      /** 유저가 보는 이름 */
      name: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 병원내 계정의 직/직책 */
      jobType: string;
    };
    /**
     * 그룹 수정 일시
     * @format date
     */
    groupModifiedAt?: string;
    /** 그룹 수정자 정보 */
    groupModifierID?: {
      /** MongoDB Identifier */
      _id: string;
      /** 실 이름 */
      realName: string;
      /** 유저가 보는 이름 */
      name: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 병원내 계정의 직/직책 */
      jobType: string;
    };
    /**
     * 컬럼 수정 일시
     * @format date
     */
    columnModifiedAt?: string;
    /** 컬럼 수정자 정보 */
    columnModifierID?: {
      /** MongoDB Identifier */
      _id: string;
      /** 실 이름 */
      realName: string;
      /** 유저가 보는 이름 */
      name: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 병원내 계정의 직/직책 */
      jobType: string;
    };
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationGroupControllerCreateBodyRequest {
  /** (required) 병원 그룹(부서) 이름 */
  title: string;
  /** (required) 병원 ID */
  hospitalID: string;
  /** 예약 생성 즉시 메시지 */
  messageImmediateCreate?: string;
  /** 예약 생성 즉시 메시지 템플릿 히스토리 ID */
  messageImmediateCreateHistoryID?: string;
  /** 예약 수정 즉시 메시지 */
  messageImmediateUpdate?: string;
  /** 예약 수정 즉시 메시지 템플릿 히스토리 ID */
  messageImmediateUpdateHistoryID?: string;
  /** 예약 삭제 즉시 메시지 */
  messageImmediateRemove?: string;
  /** 예약 삭제 즉시 메시지 템플릿 히스토리 ID */
  messageImmediateRemoveHistoryID?: string;
  /** 예약 당일 메시지 사용 여부 */
  usingMessageReservationBefore0?: boolean;
  /** 예약 당일 메시지 발송 시간 (HH:mm) */
  messageTimeReservationBefore0?: string;
  /** 예약 당일 메시지 내용 */
  messageReservationBefore0?: string;
  /** 예약 당일 메시지 템플릿 히스토리 ID */
  messageReservationBefore0HistoryID?: string;
  /** 예약 1일전 메시지 사용 여부 */
  usingMessageReservationBefore1?: boolean;
  /** 예약 1일전 메시지 발송 시간 (HH:mm) */
  messageTimeReservationBefore1?: string;
  /** 예약 1일전 메시지 내용 */
  messageReservationBefore1?: string;
  /** 예약 1일전 메시지 템플릿 히스토리 ID */
  messageReservationBefore1HistoryID?: string;
  /** 예약 3일전 메시지 사용 여부 */
  usingMessageReservationBefore3?: boolean;
  /** 예약 3일전 메시지 발송 시간 (HH:mm) */
  messageTimeReservationBefore3?: string;
  /** 예약 3일전 메시지 내용 */
  messageReservationBefore3?: string;
  /** 예약 3일전 메시지 템플릿 히스토리 ID */
  messageReservationBefore3HistoryID?: string;
  /** AI 예약 사용 여부 */
  isAi?: boolean;
  /** AI 예약 생성 즉시 메시지 */
  messageAIImmediateCreate?: string;
  /** AI 예약 생성 즉시 메시지 템플릿 히스토리 ID */
  messageAIImmediateCreateHistoryID?: string;
  /** AI 예약 확정 메시지 */
  messageAIConfirmation?: string;
  /** AI 예약 확정 메시지 템플릿 히스토리 ID */
  messageAIConfirmationHistoryID?: string;
  /** AI 예약 삭제 메시지 */
  messageAIRemove?: string;
  /** AI 예약 삭제 메시지 템플릿 히스토리 ID */
  messageAIRemoveHistoryID?: string;
}

export interface ReservationGroupControllerCreateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 그룹 ID */
    _id: string;
    /** 병원 그룹(부서) 이름 */
    title?: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 정렬 번호 */
    sortNum?: number;
    /** 예약 생성 즉시 메시지 */
    messageImmediateCreate?: string;
    /** 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 수정 즉시 메시지 */
    messageImmediateUpdate?: string;
    /** 예약 수정 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateUpdateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 삭제 즉시 메시지 */
    messageImmediateRemove?: string;
    /** 예약 삭제 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 당일 메시지 사용 여부 */
    usingMessageReservationBefore0?: boolean;
    /** 예약 당일 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore0?: string;
    /** 예약 당일 메시지 내용 */
    messageReservationBefore0?: string;
    /** 예약 당일 메시지 템플릿 히스토리 ID */
    messageReservationBefore0HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 1일전 메시지 사용 여부 */
    usingMessageReservationBefore1?: boolean;
    /** 예약 1일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore1?: string;
    /** 예약 1일전 메시지 내용 */
    messageReservationBefore1?: string;
    /** 예약 1일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore1HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 3일전 메시지 사용 여부 */
    usingMessageReservationBefore3?: boolean;
    /** 예약 3일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore3?: string;
    /** 예약 3일전 메시지 내용 */
    messageReservationBefore3?: string;
    /** 예약 3일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore3HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 사용 여부 */
    isAi?: boolean;
    /** AI 예약 생성 즉시 메시지 */
    messageAIImmediateCreate?: string;
    /** AI 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageAIImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 확정 메시지 */
    messageAIConfirmation?: string;
    /** AI 예약 확정 메시지 템플릿 히스토리 ID */
    messageAIConfirmationHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 삭제 메시지 */
    messageAIRemove?: string;
    /** AI 예약 삭제 메시지 템플릿 히스토리 ID */
    messageAIRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 컬럼 ID 배열 */
    columns?: string[];
    /** 삭제 여부 */
    isRemoved?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationGroupControllerUpdateBodyRequest {
  /** (required) group id */
  _id: string;
  /** 병원 그룹(부서) 이름 */
  title?: string;
  /** (required) 병원 ID */
  hospitalID: string;
  /** 예약 당일 안내 사용 여부 */
  usingReservationNotification?: boolean;
  /** 예약 당일 안내 발송 시간 */
  reservationNotificationTime?: string;
  /** 예약 당일 안내 발송 메시지 내용 */
  reservationNotificationMessage?: string;
  /** 예약 전날 안내 사용 여부 */
  usingReservationBNotification?: boolean;
  /** 예약 전날 안내 발송 시간 */
  reservationBNotificationTime?: string;
  /** 예약 전날 안내 발송 메시지 내용 */
  reservationBNotificationMessage?: string;
  /** 예약 생성 즉시 메시지 */
  messageImmediateCreate?: string;
  /** 예약 생성 즉시 메시지 템플릿 히스토리 ID */
  messageImmediateCreateHistoryID?: string;
  /** 예약 수정 즉시 메시지 */
  messageImmediateUpdate?: string;
  /** 예약 수정 즉시 메시지 템플릿 히스토리 ID */
  messageImmediateUpdateHistoryID?: string;
  /** 예약 삭제 즉시 메시지 */
  messageImmediateRemove?: string;
  /** 예약 삭제 즉시 메시지 템플릿 히스토리 ID */
  messageImmediateRemoveHistoryID?: string;
  /** 예약 당일 메시지 사용 여부 */
  usingMessageReservationBefore0?: boolean;
  /** 예약 당일 메시지 발송 시간 (HH:mm) */
  messageTimeReservationBefore0?: string;
  /** 예약 당일 메시지 내용 */
  messageReservationBefore0?: string;
  /** 예약 당일 메시지 템플릿 히스토리 ID */
  messageReservationBefore0HistoryID?: string;
  /** 예약 1일전 메시지 사용 여부 */
  usingMessageReservationBefore1?: boolean;
  /** 예약 1일전 메시지 발송 시간 (HH:mm) */
  messageTimeReservationBefore1?: string;
  /** 예약 1일전 메시지 내용 */
  messageReservationBefore1?: string;
  /** 예약 1일전 메시지 템플릿 히스토리 ID */
  messageReservationBefore1HistoryID?: string;
  /** 예약 3일전 메시지 사용 여부 */
  usingMessageReservationBefore3?: boolean;
  /** 예약 3일전 메시지 발송 시간 (HH:mm) */
  messageTimeReservationBefore3?: string;
  /** 예약 3일전 메시지 내용 */
  messageReservationBefore3?: string;
  /** 예약 3일전 메시지 템플릿 히스토리 ID */
  messageReservationBefore3HistoryID?: string;
  /** AI 예약 사용 여부 */
  isAi?: boolean;
  /** AI 예약 생성 즉시 메시지 */
  messageAIImmediateCreate?: string;
  /** AI 예약 생성 즉시 메시지 템플릿 히스토리 ID */
  messageAIImmediateCreateHistoryID?: string;
  /** AI 예약 확인 메시지 */
  messageAIConfirmation?: string;
  /** AI 예약 확인 메시지 템플릿 히스토리 ID */
  messageAIConfirmationHistoryID?: string;
  /** AI 예약 삭제 메시지 */
  messageAIRemove?: string;
  /** AI 예약 삭제 메시지 템플릿 히스토리 ID */
  messageAIRemoveHistoryID?: string;
}

export interface ReservationGroupControllerUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 그룹 ID */
    _id: string;
    /** 병원 그룹(부서) 이름 */
    title?: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 정렬 번호 */
    sortNum?: number;
    /** 예약 당일 안내 사용 여부 */
    usingReservationNotification?: boolean;
    /**
     * 예약 당일 안내 발송 시간
     * @format date
     */
    reservationNotificationTime?: string;
    /** 예약 당일 안내 발송 메시지 내용 */
    reservationNotificationMessage?: string;
    /** 예약 전날 안내 사용 여부 */
    usingReservationBNotification?: boolean;
    /**
     * 예약 전날 안내 발송 시간
     * @format date
     */
    reservationBNotificationTime?: string;
    /** 예약 전날 안내 발송 메시지 내용 */
    reservationBNotificationMessage?: string;
    /** 예약 생성 즉시 메시지 */
    messageImmediateCreate?: string;
    /** 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 수정 즉시 메시지 */
    messageImmediateUpdate?: string;
    /** 예약 수정 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateUpdateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 삭제 즉시 메시지 */
    messageImmediateRemove?: string;
    /** 예약 삭제 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 당일 메시지 사용 여부 */
    usingMessageReservationBefore0?: boolean;
    /** 예약 당일 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore0?: string;
    /** 예약 당일 메시지 내용 */
    messageReservationBefore0?: string;
    /** 예약 당일 메시지 템플릿 히스토리 ID */
    messageReservationBefore0HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 1일전 메시지 사용 여부 */
    usingMessageReservationBefore1?: boolean;
    /** 예약 1일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore1?: string;
    /** 예약 1일전 메시지 내용 */
    messageReservationBefore1?: string;
    /** 예약 1일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore1HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 3일전 메시지 사용 여부 */
    usingMessageReservationBefore3?: boolean;
    /** 예약 3일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore3?: string;
    /** 예약 3일전 메시지 내용 */
    messageReservationBefore3?: string;
    /** 예약 3일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore3HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 사용 여부 */
    isAi?: boolean;
    /** AI 예약 생성 즉시 메시지 커스텀 사용 여부 */
    usingCustomAIImmediateCreate?: boolean;
    /** AI 예약 생성 즉시 메시지 */
    messageAIImmediateCreate?: string;
    /** AI 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageAIImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 생성 즉시 메시지 커스텀 메시지 */
    customMessageAIImmediateCreate?: string;
    /** AI 예약 생성 즉시 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 확정 메시지 커스텀 사용 여부 */
    usingCustomAIConfirmation?: boolean;
    /** AI 예약 확인 메시지 */
    messageAIConfirmation?: string;
    /** AI 예약 확인 메시지 템플릿 히스토리 ID */
    messageAIConfirmationHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 확정 메시지 커스텀 메시지 */
    customMessageAIConfirmation?: string;
    /** AI 예약 확정 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIConfirmationHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 삭제 메시지 커스텀 사용 여부 */
    usingCustomAIRemove?: boolean;
    /** AI 예약 삭제 메시지 */
    messageAIRemove?: string;
    /** AI 예약 삭제 메시지 템플릿 히스토리 ID */
    messageAIRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 삭제 메시지 커스텀 메시지 */
    customMessageAIRemove?: string;
    /** AI 예약 삭제 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 컬럼 ID 배열 */
    columns?: string[];
    /** 수정자 ID (populate된 경우 객체) */
    modifierID?:
      | string
      | {
          /** 사용자 ID */
          _id?: string;
          /** 고객에게 보이는 이름 */
          name?: string;
          /** 이름 */
          realName?: string;
          /** 유저 타입 */
          type?: string;
          /** 병원 내 계정의 직책, 직급 */
          jobType?: string;
        };
    /** 삭제 여부 */
    isRemoved?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
    /**
     * 삭제된 일시
     * @format date
     */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationGroupControllerAiGroupGetResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 그룹 ID */
    _id: string;
    /** 병원 그룹(부서) 이름 */
    title?: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 정렬 번호 */
    sortNum?: number;
    /** 예약 당일 안내 사용 여부 */
    usingReservationNotification?: boolean;
    /**
     * 예약 당일 안내 발송 시간
     * @format date
     */
    reservationNotificationTime?: string;
    /** 예약 당일 안내 발송 메시지 내용 */
    reservationNotificationMessage?: string;
    /** 예약 전날 안내 사용 여부 */
    usingReservationBNotification?: boolean;
    /**
     * 예약 전날 안내 발송 시간
     * @format date
     */
    reservationBNotificationTime?: string;
    /** 예약 전날 안내 발송 메시지 내용 */
    reservationBNotificationMessage?: string;
    /** 예약 생성 즉시 메시지 */
    messageImmediateCreate?: string;
    /** 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 수정 즉시 메시지 */
    messageImmediateUpdate?: string;
    /** 예약 수정 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateUpdateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 삭제 즉시 메시지 */
    messageImmediateRemove?: string;
    /** 예약 삭제 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 당일 메시지 사용 여부 */
    usingMessageReservationBefore0?: boolean;
    /** 예약 당일 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore0?: string;
    /** 예약 당일 메시지 내용 */
    messageReservationBefore0?: string;
    /** 예약 당일 메시지 템플릿 히스토리 ID */
    messageReservationBefore0HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 1일전 메시지 사용 여부 */
    usingMessageReservationBefore1?: boolean;
    /** 예약 1일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore1?: string;
    /** 예약 1일전 메시지 내용 */
    messageReservationBefore1?: string;
    /** 예약 1일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore1HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 3일전 메시지 사용 여부 */
    usingMessageReservationBefore3?: boolean;
    /** 예약 3일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore3?: string;
    /** 예약 3일전 메시지 내용 */
    messageReservationBefore3?: string;
    /** 예약 3일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore3HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 사용 여부 */
    isAi?: boolean;
    /** AI 예약 생성 즉시 메시지 커스텀 사용 여부 */
    usingCustomAIImmediateCreate?: boolean;
    /** AI 예약 생성 즉시 메시지 */
    messageAIImmediateCreate?: string;
    /** AI 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageAIImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 생성 즉시 메시지 커스텀 메시지 */
    customMessageAIImmediateCreate?: string;
    /** AI 예약 생성 즉시 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 확정 메시지 커스텀 사용 여부 */
    usingCustomAIConfirmation?: boolean;
    /** AI 예약 확인 메시지 */
    messageAIConfirmation?: string;
    /** AI 예약 확인 메시지 템플릿 히스토리 ID */
    messageAIConfirmationHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 확정 메시지 커스텀 메시지 */
    customMessageAIConfirmation?: string;
    /** AI 예약 확정 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIConfirmationHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 삭제 메시지 커스텀 사용 여부 */
    usingCustomAIRemove?: boolean;
    /** AI 예약 삭제 메시지 */
    messageAIRemove?: string;
    /** AI 예약 삭제 메시지 템플릿 히스토리 ID */
    messageAIRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 삭제 메시지 커스텀 메시지 */
    customMessageAIRemove?: string;
    /** AI 예약 삭제 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 컬럼 ID 배열 */
    columns?: string[];
    /** 수정자 ID (populate된 경우 객체) */
    modifierID?:
      | string
      | {
          /** 사용자 ID */
          _id?: string;
          /** 고객에게 보이는 이름 */
          name?: string;
          /** 이름 */
          realName?: string;
          /** 유저 타입 */
          type?: string;
          /** 병원 내 계정의 직책, 직급 */
          jobType?: string;
        };
    /** 삭제 여부 */
    isRemoved?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
    /**
     * 삭제된 일시
     * @format date
     */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationGroupControllerAiUpdateBodyRequest {
  /** (required) group id */
  _id: string;
  /** (required) 병원 ID */
  hospitalID: string;
  /** AI 예약 생성 즉시 메시지 커스텀 사용 여부 */
  usingCustomAIImmediateCreate: boolean;
  /** AI 예약 생성 즉시 메시지 커스텀 메시지 */
  customMessageAIImmediateCreate: string;
  /** AI 예약 확정 메시지 커스텀 사용 여부 */
  usingCustomAIConfirmation: boolean;
  /** AI 예약 확정 메시지 커스텀 메시지 */
  customMessageAIConfirmation: string;
  /** AI 예약 삭제 메시지 커스텀 사용 여부 */
  usingCustomAIRemove: boolean;
  /** AI 예약 삭제 메시지 커스텀 메시지 */
  customMessageAIRemove: string;
}

export interface ReservationGroupControllerAiUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 그룹 ID */
    _id: string;
    /** 병원 그룹(부서) 이름 */
    title?: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 정렬 번호 */
    sortNum?: number;
    /** 예약 당일 안내 사용 여부 */
    usingReservationNotification?: boolean;
    /**
     * 예약 당일 안내 발송 시간
     * @format date
     */
    reservationNotificationTime?: string;
    /** 예약 당일 안내 발송 메시지 내용 */
    reservationNotificationMessage?: string;
    /** 예약 전날 안내 사용 여부 */
    usingReservationBNotification?: boolean;
    /**
     * 예약 전날 안내 발송 시간
     * @format date
     */
    reservationBNotificationTime?: string;
    /** 예약 전날 안내 발송 메시지 내용 */
    reservationBNotificationMessage?: string;
    /** 예약 생성 즉시 메시지 */
    messageImmediateCreate?: string;
    /** 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 수정 즉시 메시지 */
    messageImmediateUpdate?: string;
    /** 예약 수정 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateUpdateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 삭제 즉시 메시지 */
    messageImmediateRemove?: string;
    /** 예약 삭제 즉시 메시지 템플릿 히스토리 ID */
    messageImmediateRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 당일 메시지 사용 여부 */
    usingMessageReservationBefore0?: boolean;
    /** 예약 당일 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore0?: string;
    /** 예약 당일 메시지 내용 */
    messageReservationBefore0?: string;
    /** 예약 당일 메시지 템플릿 히스토리 ID */
    messageReservationBefore0HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 1일전 메시지 사용 여부 */
    usingMessageReservationBefore1?: boolean;
    /** 예약 1일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore1?: string;
    /** 예약 1일전 메시지 내용 */
    messageReservationBefore1?: string;
    /** 예약 1일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore1HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 3일전 메시지 사용 여부 */
    usingMessageReservationBefore3?: boolean;
    /** 예약 3일전 메시지 발송 시간 (HH:mm) */
    messageTimeReservationBefore3?: string;
    /** 예약 3일전 메시지 내용 */
    messageReservationBefore3?: string;
    /** 예약 3일전 메시지 템플릿 히스토리 ID */
    messageReservationBefore3HistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 사용 여부 */
    isAi?: boolean;
    /** AI 예약 생성 즉시 메시지 커스텀 사용 여부 */
    usingCustomAIImmediateCreate?: boolean;
    /** AI 예약 생성 즉시 메시지 */
    messageAIImmediateCreate?: string;
    /** AI 예약 생성 즉시 메시지 템플릿 히스토리 ID */
    messageAIImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 생성 즉시 메시지 커스텀 메시지 */
    customMessageAIImmediateCreate?: string;
    /** AI 예약 생성 즉시 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIImmediateCreateHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 확정 메시지 커스텀 사용 여부 */
    usingCustomAIConfirmation?: boolean;
    /** AI 예약 확인 메시지 */
    messageAIConfirmation?: string;
    /** AI 예약 확인 메시지 템플릿 히스토리 ID */
    messageAIConfirmationHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 확정 메시지 커스텀 메시지 */
    customMessageAIConfirmation?: string;
    /** AI 예약 확정 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIConfirmationHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 삭제 메시지 커스텀 사용 여부 */
    usingCustomAIRemove?: boolean;
    /** AI 예약 삭제 메시지 */
    messageAIRemove?: string;
    /** AI 예약 삭제 메시지 템플릿 히스토리 ID */
    messageAIRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** AI 예약 삭제 메시지 커스텀 메시지 */
    customMessageAIRemove?: string;
    /** AI 예약 삭제 메시지 커스텀 메시지 템플릿 히스토리 ID */
    customMessageAIRemoveHistoryID?:
      | string
      | {
          /** 템플릿 히스토리 ID */
          _id?: string;
          /** 템플릿 코드 */
          templateCode?: string;
          /** 템플릿 이름 */
          templateName?: string;
          /** 템플릿 내용 */
          templateContent?: string;
          /** 검수 상태 */
          inspectionStatus?: string;
        };
    /** 예약 컬럼 ID 배열 */
    columns?: string[];
    /** 수정자 ID (populate된 경우 객체) */
    modifierID?:
      | string
      | {
          /** 사용자 ID */
          _id?: string;
          /** 고객에게 보이는 이름 */
          name?: string;
          /** 이름 */
          realName?: string;
          /** 유저 타입 */
          type?: string;
          /** 병원 내 계정의 직책, 직급 */
          jobType?: string;
        };
    /** 삭제 여부 */
    isRemoved?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
    /**
     * 수정된 일시
     * @format date
     */
    modifiedAt?: string;
    /**
     * 삭제된 일시
     * @format date
     */
    removedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationControllerFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 예약 ID */
    _id: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 병원서비스 (populate) */
    hserviceID?: any;
    /** 예약 그룹 (populate) */
    groupID?: any;
    /** 예약 컬럼 (populate) */
    columnID?: any;
    /** 프로그램 (populate) */
    programID?: any;
    /** 예약 상태 (populate) */
    statusID?: any;
    /** 작성자 (populate: name, realName, type, jobType) */
    writerID?: any;
    /** 수정자 (populate: name, realName, type, jobType) */
    modifierID?: any;
    /** 고객 ID */
    userID?: string;
    /** 고객 이름 */
    userName?: string;
    /**
     * 예약 시작 시간
     * @format date
     */
    startedAt?: string;
    /**
     * 예약 종료 시간
     * @format date
     */
    endedAt?: string;
    /** 예약 시간(분) */
    duration?: number;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /** 취소 여부 */
    isCanceled?: boolean;
    /** 초진 여부 */
    isFirstVisit?: boolean;
    /** 테스트 여부 */
    isTest?: boolean;
    /** 예약 메모 */
    note?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationControllerCreateBodyRequest {
  /** (required) 병원 ID */
  hospitalID: string;
  /** (required) 예약 그룹(부서) ID */
  groupID: string;
  /** (required) 예약 컬럼(담당자) ID */
  columnID: string;
  /** (required) 프로그램 ID */
  programID: string;
  /** (required) 예약 상태 ID */
  statusID: string;
  /** (required) 예약을 받을 고객의 ID */
  userID: string;
  /** (required) 병원서비스 ID */
  hserviceID: string;
  /** (required) 예약 시작 시간 */
  startedAt: string;
  /** (required) 예약 종료 시간 */
  endedAt: string;
  /** 예약건에 대한 예약 메모 */
  note?: string;
}

export interface ReservationControllerCreateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 예약 ID */
    _id: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 예약 그룹 ID */
    groupID?: string;
    /** 예약 컬럼 ID */
    columnID?: string;
    /** 프로그램 ID */
    programID?: string;
    /** 예약 상태 ID */
    statusID?: string;
    /** 고객 ID */
    userID?: string;
    /** 병원서비스 ID */
    hserviceID?: string;
    /**
     * 예약 시작 시간
     * @format date
     */
    startedAt?: string;
    /**
     * 예약 종료 시간
     * @format date
     */
    endedAt?: string;
    /** 예약 시간(분) */
    duration?: number;
    /** 고객 이름 */
    userName?: string;
    /** 그룹 이름 */
    groupTitle?: string;
    /** 컬럼 이름 */
    columnTitle?: string;
    /** 프로그램 이름 */
    programTitle?: string;
    /** 상태 이름 */
    statusTitle?: string;
    /** 작성자 이름 */
    writerName?: string;
    /** 작성자 ID */
    writerID?: string;
    /** 작성자 타입 */
    writerType?: number;
    /** 취소 여부 */
    isCanceled?: boolean;
    /** 초진 여부 */
    isFirstVisit?: boolean;
    /** 예약 메모 */
    note?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationControllerUpdateBodyRequest {
  /** (required) 예약 ID */
  _id: string;
  /** (required) 병원 ID */
  hospitalID: string;
  /** (required) 병원서비스 ID */
  hserviceID: string;
  /** (required) 예약을 받을 고객의 ID */
  userID: string;
  /** (required) 예약 그룹(부서) ID */
  groupID: string;
  /** (required) 예약 컬럼(담당자) ID */
  columnID: string;
  /** 예약 시작 시간 */
  startedAt?: string;
  /** 예약 종료 시간 */
  endedAt?: string;
  /** 프로그램 ID */
  programID?: string;
  /** 예약 상태 ID */
  statusID?: string;
  /** 예약건에 대한 예약 메모 (null 전달 시 메모 삭제) */
  note?: string | null;
}

export interface ReservationControllerUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 예약 ID */
    _id: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 예약 그룹 ID */
    groupID?: string;
    /** 예약 컬럼 ID */
    columnID?: string;
    /** 프로그램 ID */
    programID?: string;
    /** 예약 상태 ID */
    statusID?: string;
    /** 고객 ID */
    userID?: string;
    /** 병원서비스 ID */
    hserviceID?: string;
    /**
     * 예약 시작 시간
     * @format date
     */
    startedAt?: string;
    /**
     * 예약 종료 시간
     * @format date
     */
    endedAt?: string;
    /** 예약 시간(분) */
    duration?: number;
    /** 고객 이름 */
    userName?: string;
    /** 그룹 이름 */
    groupTitle?: string;
    /** 컬럼 이름 */
    columnTitle?: string;
    /** 프로그램 이름 */
    programTitle?: string;
    /** 상태 이름 */
    statusTitle?: string;
    /** 작성자 이름 */
    writerName?: string;
    /** 작성자 ID */
    writerID?: string;
    /** 작성자 타입 */
    writerType?: number;
    /** 취소 여부 */
    isCanceled?: boolean;
    /** 초진 여부 */
    isFirstVisit?: boolean;
    /** 예약 메모 */
    note?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationControllerRemoveResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 예약 ID */
    _id: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 예약 그룹 ID */
    groupID?: string;
    /** 예약 컬럼 ID */
    columnID?: string;
    /** 프로그램 ID */
    programID?: string;
    /** 예약 상태 ID */
    statusID?: string;
    /** 고객 ID */
    userID?: string;
    /** 병원서비스 ID */
    hserviceID?: string;
    /**
     * 예약 시작 시간
     * @format date
     */
    startedAt?: string;
    /**
     * 예약 종료 시간
     * @format date
     */
    endedAt?: string;
    /** 예약 시간(분) */
    duration?: number;
    /** 고객 이름 */
    userName?: string;
    /** 그룹 이름 */
    groupTitle?: string;
    /** 컬럼 이름 */
    columnTitle?: string;
    /** 프로그램 이름 */
    programTitle?: string;
    /** 상태 이름 */
    statusTitle?: string;
    /** 작성자 이름 */
    writerName?: string;
    /** 작성자 ID */
    writerID?: string;
    /** 작성자 타입 */
    writerType?: number;
    /** 취소 여부 */
    isCanceled?: boolean;
    /** 초진 여부 */
    isFirstVisit?: boolean;
    /** 예약 메모 */
    note?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 수정 일시
     * @format date
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationControllerSendPushBodyRequest {
  /** (required) 발송할 Push Action 명. create, update, cancel, remove */
  action: string;
  /** (required) 예약 ID */
  reservationID: string;
}

export interface ReservationControllerSendPushResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 발송 결과 */
    result?: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ReservationControllerSendAiPushBodyRequest {
  /** (required) 발송할 Push Action 명. create, update, cancel, remove */
  action: string;
  /** (required) 예약 ID */
  reservationID: string;
}

export interface ReservationControllerSendAiPushResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 발송 결과 */
    result?: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface NoteControllerFindParams {
  /** 병원서비스 ID */
  hserviceID: string;
  /** 환자의 user ID */
  userID: string;
}

export type NoteControllerFindData = NoteControllerFindResponse;

export type NoteControllerUpdateData = NoteControllerUpdateResponse;

export interface ColumnControllerFindParams {
  /** 병원 ID */
  hospitalID: string;
  /** 예약 그룹(부서) ID 배열. 표준 방식: groupID=value1&groupID=value2 */
  groupID?: string[] | null;
  /** 예약 그룹(부서) ID 배열 (하위 호환) */
  "groupID[]"?: string[] | null;
  /** 컬럼(담당자) 이름 */
  title?: string;
  /** 생성 일자. json parse 처리됨 */
  createdAt?: string;
  /** 삭제 여부. json parse 처리됨 (예: "false", "true") */
  isRemoved?: string;
  /** 삭제 일자. json parse 처리됨. 입력될 경우, removedAt이 없는 케이스도 포함되도록 쿼리 수정 */
  removedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number | null;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number | null;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number | null;
}

export type ColumnControllerFindData = ColumnControllerFindResponse;

export type ColumnControllerData = ColumnControllerCreateResponse;

export interface ColumnControllerAiColumnGetParams {
  /** (required) 병원 ID */
  hospitalID: string;
}

export type ColumnControllerAiColumnGetData = ColumnControllerAiColumnGetResponse;

export type ColumnControllerAiColumnUpdateData = ColumnControllerAiColumnUpdateResponse;

export interface ReservationSettingControllerFindParams {
  /** 병원 ID */
  hospitalID: string;
}

export type ReservationSettingControllerFindData = ReservationSettingControllerFindResponse;

export type ReservationGroupControllerData = ReservationGroupControllerCreateResponse;

export type ReservationGroupControllerUpdateData = ReservationGroupControllerUpdateResponse;

export interface ReservationGroupControllerAiGroupGetParams {
  /** (required) 병원 ID */
  hospitalID: string;
}

export type ReservationGroupControllerAiGroupGetData = ReservationGroupControllerAiGroupGetResponse;

export type ReservationGroupControllerAiUpdateData = ReservationGroupControllerAiUpdateResponse;

export interface ReservationControllerFindParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 서비스 ID */
  hserviceID?: string;
  /** 예약 그룹(부서) ID */
  groupID?: string;
  /** 예약 담당자(컬럼) ID */
  columnID?: string;
  /** 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string | string[];
  /** 삭제 여부 (boolean string) */
  isRemoved?: string;
  /** 조회 범위 시작 일시 (ISO 8601) */
  startedAt?: string;
  /** 조회 범위 종료 일시 (ISO 8601) */
  endedAt?: string;
  /** 테스트 계정 여부 플래그 */
  isTest?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number | null;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number | null;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number | null;
}

export type ReservationControllerFindData = ReservationControllerFindResponse;

export type ReservationControllerData = ReservationControllerCreateResponse;

export type ReservationControllerUpdateData = ReservationControllerUpdateResponse;

export interface ReservationControllerRemoveParams {
  /** (required) 삭제할 예약 ID */
  _id: string;
}

export type ReservationControllerRemoveData = ReservationControllerRemoveResponse;

export type ReservationControllerSendPushData = ReservationControllerSendPushResponse;

export type ReservationControllerSendAiPushData = ReservationControllerSendAiPushResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-ReservationNote
     * @name NoteControllerFind
     * @summary 병원서비스별 치료 내역 (예약 치료내역) 조회
     * @request GET:/v3/api/reservation/note
     * @deprecated
     * @secure
     * @response `200` `NoteControllerFindData` success
     */
    noteControllerFind: (query: NoteControllerFindParams, params: RequestParams = {}) =>
      this.request<NoteControllerFindData, any>({
        path: `/v3/api/reservation/note`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description userID, hospitalID, hserviceID 세가지를 기준으로 upsert 동작
     *
     * @tags V3-ReservationNote
     * @name NoteControllerUpdate
     * @summary 병원서비스별 치료 내역 (예약 치료내역) 수정
     * @request POST:/v3/api/reservation/note
     * @deprecated
     * @secure
     * @response `200` `NoteControllerUpdateData` success
     */
    noteControllerUpdate: (data: NoteControllerUpdateBodyRequest, params: RequestParams = {}) =>
      this.request<NoteControllerUpdateData, any>({
        path: `/v3/api/reservation/note`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ReservationColumn
     * @name ColumnControllerFind
     * @summary 병원 예약 컬럼(담당자) 목록 조회
     * @request GET:/v3/api/reservation/column
     * @secure
     * @response `200` `ColumnControllerFindData` success
     */
    columnControllerFind: (query: ColumnControllerFindParams, params: RequestParams = {}) =>
      this.request<ColumnControllerFindData, any>({
        path: `/v3/api/reservation/column`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ReservationColumn
     * @name ColumnController
     * @summary 병원 예약 컬럼(담당자) 생성
     * @request POST:/v3/api/reservation/column
     * @secure
     * @response `200` `ColumnControllerData` success
     */
    columnController: (data: ColumnControllerCreateBodyRequest, params: RequestParams = {}) =>
      this.request<ColumnControllerData, any>({
        path: `/v3/api/reservation/column`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Ai-Reservation
     * @name ColumnControllerAiColumnGet
     * @summary AI 예약 컬럼 조회
     * @request GET:/v3/api/reservation/column/ai
     * @secure
     * @response `200` `ColumnControllerAiColumnGetData` success
     */
    columnControllerAiColumnGet: (query: ColumnControllerAiColumnGetParams, params: RequestParams = {}) =>
      this.request<ColumnControllerAiColumnGetData, any>({
        path: `/v3/api/reservation/column/ai`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Ai-Reservation
     * @name ColumnControllerAiColumnUpdate
     * @summary AI 예약 컬럼 수정
     * @request PATCH:/v3/api/reservation/column/ai
     * @secure
     * @response `200` `ColumnControllerAiColumnUpdateData` success
     */
    columnControllerAiColumnUpdate: (data: ColumnControllerAiColumnUpdateBodyRequest, params: RequestParams = {}) =>
      this.request<ColumnControllerAiColumnUpdateData, any>({
        path: `/v3/api/reservation/column/ai`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ReservationSetting
     * @name ReservationSettingControllerFind
     * @summary 병원 예약 설정 조회 (정보가 없는 경우 디폴트 정보를 생성 후 리턴)
     * @request GET:/v3/api/reservation/setting
     * @secure
     * @response `200` `ReservationSettingControllerFindData` success
     */
    reservationSettingControllerFind: (query: ReservationSettingControllerFindParams, params: RequestParams = {}) =>
      this.request<ReservationSettingControllerFindData, any>({
        path: `/v3/api/reservation/setting`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ReservationGroup
     * @name ReservationGroupController
     * @summary 병원 예약 그룹(부서) 생성
     * @request POST:/v3/api/reservation/group
     * @secure
     * @response `200` `ReservationGroupControllerData` success
     */
    reservationGroupController: (data: ReservationGroupControllerCreateBodyRequest, params: RequestParams = {}) =>
      this.request<ReservationGroupControllerData, any>({
        path: `/v3/api/reservation/group`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ReservationGroup
     * @name ReservationGroupControllerUpdate
     * @summary 병원 예약 그룹(부서) 수정
     * @request PATCH:/v3/api/reservation/group
     * @secure
     * @response `200` `ReservationGroupControllerUpdateData` success
     */
    reservationGroupControllerUpdate: (data: ReservationGroupControllerUpdateBodyRequest, params: RequestParams = {}) =>
      this.request<ReservationGroupControllerUpdateData, any>({
        path: `/v3/api/reservation/group`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 예약 그룹 조회
     *
     * @tags V3-Ai-Reservation
     * @name ReservationGroupControllerAiGroupGet
     * @summary AI 예약 그룹 조회
     * @request GET:/v3/api/reservation/group/ai
     * @secure
     * @response `200` `ReservationGroupControllerAiGroupGetData` success
     */
    reservationGroupControllerAiGroupGet: (
      query: ReservationGroupControllerAiGroupGetParams,
      params: RequestParams = {},
    ) =>
      this.request<ReservationGroupControllerAiGroupGetData, any>({
        path: `/v3/api/reservation/group/ai`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 예약 그룹 수정
     *
     * @tags V3-Ai-Reservation
     * @name ReservationGroupControllerAiUpdate
     * @summary AI 예약 그룹 수정
     * @request PATCH:/v3/api/reservation/group/ai
     * @secure
     * @response `200` `ReservationGroupControllerAiUpdateData` success
     */
    reservationGroupControllerAiUpdate: (
      data: ReservationGroupControllerAiUpdateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReservationGroupControllerAiUpdateData, any>({
        path: `/v3/api/reservation/group/ai`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ReservationControllerFind
     * @summary 예약 객체의 조회
     * @request GET:/v3/api/reservation/find
     * @secure
     * @response `200` `ReservationControllerFindData` success
     */
    reservationControllerFind: (query: ReservationControllerFindParams, params: RequestParams = {}) =>
      this.request<ReservationControllerFindData, any>({
        path: `/v3/api/reservation/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ReservationController
     * @summary 예약 등록
     * @request POST:/v3/api/reservation
     * @secure
     * @response `200` `ReservationControllerData` success
     */
    reservationController: (data: ReservationControllerCreateBodyRequest, params: RequestParams = {}) =>
      this.request<ReservationControllerData, any>({
        path: `/v3/api/reservation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ReservationControllerUpdate
     * @summary 예약 수정 및 취소(statusID 따라서 수정, 취소 처리)
     * @request PATCH:/v3/api/reservation
     * @secure
     * @response `200` `ReservationControllerUpdateData` success
     */
    reservationControllerUpdate: (data: ReservationControllerUpdateBodyRequest, params: RequestParams = {}) =>
      this.request<ReservationControllerUpdateData, any>({
        path: `/v3/api/reservation`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ReservationControllerRemove
     * @summary 예약 객체 삭제
     * @request DELETE:/v3/api/reservation
     * @secure
     * @response `200` `ReservationControllerRemoveData` success
     */
    reservationControllerRemove: (query: ReservationControllerRemoveParams, params: RequestParams = {}) =>
      this.request<ReservationControllerRemoveData, any>({
        path: `/v3/api/reservation`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ReservationControllerSendPush
     * @summary 예약 SaaS 푸시 발송
     * @request POST:/v3/api/reservation/send-push
     * @secure
     * @response `200` `ReservationControllerSendPushData` success
     */
    reservationControllerSendPush: (data: ReservationControllerSendPushBodyRequest, params: RequestParams = {}) =>
      this.request<ReservationControllerSendPushData, any>({
        path: `/v3/api/reservation/send-push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ReservationControllerSendAiPush
     * @summary AI 예약 확정/취소 푸시 발송
     * @request POST:/v3/api/reservation/send-ai-push
     * @secure
     * @response `200` `ReservationControllerSendAiPushData` success
     */
    reservationControllerSendAiPush: (data: ReservationControllerSendAiPushBodyRequest, params: RequestParams = {}) =>
      this.request<ReservationControllerSendAiPushData, any>({
        path: `/v3/api/reservation/send-ai-push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
